import mapapalIcon from '../assets/brand/mapapal-icon.png'

export function LoadingBrandPulse({ className = '' }: { className?: string }) {
  return (
    <img
      className={`loading-brand-pulse${className ? ` ${className}` : ''}`}
      src={mapapalIcon}
      alt=""
      aria-hidden="true"
    />
  )
}
